import React, { useMemo } from 'react';
import { Tooltip, TOOLTIP_POSITION } from 'taboola-ultimate-ui';
import { unescapeEmojis } from 'modules/codeless-events/utils/stringUtils';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './buttonClickSubtitle.module.scss';

export const ButtonClickSubtitle = ({ event }) => {
    const { formatMessage } = useIntl();

    const { displayText, hasOverflow, fullText } = useMemo(() => {
        const trackedElements = event.trackedElements || [];
        const displayTexts = trackedElements.map(element => element.displayText);

        if (displayTexts.length === 0) {
            return { displayText: event.eventName || '', hasOverflow: false, fullText: event.eventName || '' };
        }

        const quotedTexts = displayTexts.map(text => `'${text}'`);
        const orSeparator = formatMessage({
            id: 'codeless.conversion.button.separator.or',
            defaultMessage: ' OR ',
        });
        const joinedText = quotedTexts.join(orSeparator);

        return {
            displayText: joinedText,
            hasOverflow: joinedText.length > 40,
            fullText: joinedText,
        };
    }, [event, formatMessage]);

    const subtitleContent = (
        <span className={styles['subtitle-content']}>
            <FormattedMessage
                id="codeless.conversion.button.event"
                defaultMessage="Button click - `{eventName}`"
                values={{
                    eventName: unescapeEmojis(displayText),
                }}
            />
        </span>
    );

    if (hasOverflow) {
        return (
            <Tooltip
                position={TOOLTIP_POSITION.TOP}
                content={<div className={styles['tooltip-content']}>{fullText}</div>}
            >
                {subtitleContent}
            </Tooltip>
        );
    }

    return subtitleContent;
};
